import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  template: `
    <app-image-editor
      [source]="data.source"
      [initialFilters]="data.filters"
      (apply)="onApply($event)"
      (cancel)="dialogRef.close()">
    </app-image-editor>
  `,
  host: { class: 'image-editor-dialog' },
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .image-editor-dialog.mat-dialog-container { padding: 0; }
  `]
})
export class ImageEditorDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ImageEditorDialogComponent>
  ) {}

    onApply(result) {
    this.dialogRef.close(result);
  }
}
